// Picks from the AAROH album (IIIT Delhi, 1–2 August 2026) used by the /impact story.
import { AAROH_ALBUM, AAROH_CLIPS } from "../../../data/album.js";

const byId = Object.fromEntries(AAROH_ALBUM.map((photo) => [photo.id, photo]));
const clipById = Object.fromEntries(AAROH_CLIPS.map((clip) => [clip.id, clip]));

// Falls back to the best-ranked photo in a category if a chosen id ever leaves the album.
function pick(id, category) {
  if (byId[id]) return byId[id];
  return [...AAROH_ALBUM].filter((photo) => photo.category === category).sort((a, b) => a.rank - b.rank)[0] ?? AAROH_ALBUM[0];
}

export const CROWD = pick("M054", "crowd");
export const LECTERN = pick("M682", "presenting");
export const BUILDING = ["M102", "M104", "M580", "M189"].map((id) => pick(id, "building"));
export const AWARDS = ["M609", "M631", "M604", "M655"].map((id) => pick(id, "awards"));
export const TORCHES = clipById.M129 ?? AAROH_CLIPS.find((clip) => clip.category === "crowd") ?? null;
